/*eslint perfectionist/sort-objects: "error"*/
import type { UUID } from "utils";

export const TEST_IDS = {
  accountAsideCard: "account-aside-card",
  accountAsideInstantSettlementButton:
    "account-aside-instant-settlement-button",
  accountAsideNextScheduled: "account-aside-next-scheduled-card",
  accountAsideNextSettlement: "account-aside-next-settlement-card",
  accountAsideReserve: "account-aside-reserve-card",
  accountAsideSettlementAmount: "account-aside-settlement-amount-card",
  accountAsideSettlementSchedule: "account-aside-settlement-schedule-card",
  accountAsideSettlementThreshold: "account-aside-settlement-threshold-card",
  accountDetailsBreadcrumb: "account-details-breadcrumb",
  accountDetailsCardAccountHolderName:
    "account-details-card-account-holder-name",
  accountDetailsCardAccountName: "account-details-card-account-name",
  accountDetailsCardActiveToggle: "cash-management-account-status",
  accountDetailsCardCurrency:
    "cash-management-account-location-and-accepted-payments-currency",
  accountDetailsCardCustomerName: "account-details-card-customer-name",
  accountDetailsCardId: "account-details-card-id",
  accountDetailsTab: "account-details-tab",
  accountIdentificationsCardAccountNumber:
    "cash-management-account-details-account-number",
  accountIdentificationsCardAuAccountNumber:
    "account-identifications-card-au-account-number",
  accountIdentificationsCardBsb: "account-identifications-card-bsb",
  accountIdentificationsCardIban: "cash-management-account-details-iban",
  accountIdentificationsCardRouting: "account-identifications-card-routing",
  accountIdentificationsCardSortCode: "cash-management-account-details-routing",
  accountIdentificationsCardSwiftBic:
    "cash-management-account-details-swift-bic",
  accountIdentificationsCardUsAccountNumber:
    "account-identifications-card-Us-account-number",
  accountIdentificationsCardWalletId: "cash-management-wallet-id-content",
  accountIdentifierCardId: "account-identifier-card-id",
  accountIdentifierCardNickname: "cash-management-account-nickname",
  accountListCreateAccountButton: "button-add-account",
  accountsTab: "accounts-tab",
  breadcrumbPayoutNotifications: "breadcrumb-payout-notifications",
  companyUuid: "cash-management-account-company-uuid",
  companyUuidClipboardButton:
    "cash-management-account-company-uuid-clipboard-button",
  configureReportNotificationsButton: "configure-report-notifications",
  connectBreadcrumb: "connect-nav-link",
  convertFxButton: "convert-fx-button",
  convertFxDialog: "convert-fx-dialog",
  convertFxFormAccountFrom: "convert-fx-form-account-from",
  convertFxFormAccountTo: "convert-fx-form-account-to",
  convertFxFormAmount: "convert-fx-form-amount",
  convertFxFormReference: "convert-fx-form-reference",
  createAccountAccountNumber: "account-account-number",
  createAccountBreadcrumb: "create-account-breadcrumb",
  createAccountFormAccountHolderName: "account-holder-name",
  createAccountFormAuAccountNumber: "account-account-number",
  createAccountFormBsb: "bsb",
  createAccountFormCountry: "create-account-form-country",
  createAccountFormCurrency: "account-currencies",
  createAccountFormEnableSettlementModelLabel:
    "account-instruct-settlement-batches",
  createAccountFormEnableSettlementModelToggle:
    "cash-management-provider-settlement",
  createAccountFormIban: "account-iban",
  createAccountFormMasterAccountNumber:
    "cash-management-banking-circle-master-account-number",
  createAccountFormNickname: "account-nickname",
  createAccountFormProvider: "cash-management-provider",
  createAccountFormSwiftBic: "account-swift-bic",
  createAccountFormVoltAccountId: "volt-cash-management-bank-volt-account-id",
  createAccountFormWalletId: "cash-management-wallet-id",
  createAccountOpenProviderConfiguration: "button-go-provider-edit",
  createAccountRouting: "account-routing",
  creditNotificationsCardActiveToggle:
    "credit-notifications-card-active-toggle",
  creditNotificationsCardActiveToggleDisabled:
    "credit-notifications-card-active-toggle-disabled",
  creditNotificationsCardActiveToggleEnabled:
    "credit-notifications-card-active-toggle-enabled",
  creditNotificationsCardConfigureButton: "credit-notifications-configure",
  creditNotificationsCardDropdownButton:
    "credit-notifications-card-dropdown-button",
  creditNotificationsCardEditButton: "credit-notifications-card-edit-button",
  creditNotificationsCardFailingNotificationsEmail:
    "cash-management-report-notifications-alert-email",
  creditNotificationsCardNotificationsSecret:
    "cash-management-credit-notifications-secret",
  creditNotificationsCardNotificationsUrl:
    "cash-management-credit-notifications-url",
  creditNotificationsCardStatus: "credit-notifications-card-status",
  creditNotificationsCardTestButton: "credit-notifications-card-test-button",
  creditNotificationsFormEmail: "credit-notifications-form-email",
  creditNotificationsFormUrl: "credit-notifications-form-url",
  downloadSettlementReportButton: "download-settlement-report-button",
  filters: {
    amountFrom: "settlements-filters-amount-from-filter",
    amountTo: "settlements-filters-amount-to-filter",
    content: "settlements-filters-content",
    currencyFilter: "settlements-filters-currency-filter",
    modal: "settlements-filters-modal",
    statusFilter: "settlements-filters-status-filter",
    triggerFilter: "settlements-filters-trigger-filter",
  },
  getAccountListBalanceCell: (id: UUID) =>
    `account-list-row-${id}-balance-cell`,
  getAccountListCurrencyCell: (id: UUID) =>
    `account-list-row-${id}-currency-cell`,
  getAccountListRowExpandedContentNextSettlementDate: (id: UUID) =>
    `account-list-row-expanded-content-${id}-next-settlement-date`,
  getAccountListRowExpandedContentSettlementLimit: (id: UUID) =>
    `account-list-row-expanded-content-${id}-settlement-limit`,
  getAccountListRowExpandedContentSettlementSchedule: (id: UUID) =>
    `account-list-row-expanded-content-${id}-settlement-schedule`,
  getAccountListRowExpandedContentSettlementThreshold: (id: UUID) =>
    `account-list-row-expanded-content-${id}-settlement-threshold`,
  getAccountListSettlementAmountCell: (id: UUID) =>
    `account-list-row-${id}-settlement-amount-cell`,
  getAccountListStatusCell: (id: UUID) => `account-list-row-${id}-status-cell`,
  getAccountSettlementSummaryItem: (accountId: UUID) =>
    `account-settlement-summary-item-${accountId}`,
  getProviderConfigListProvider: (providerName: string) =>
    `cash-management-configurable-providers-${providerName}`,
  getProviderConfigListProviderConfigured: (providerName: string) =>
    `cash-management-configurable-providers-${providerName}-configured`,
  getProviderConfigListProviderEdit: (providerName: string) =>
    `cash-management-configurable-providers-${providerName}-edit`,
  getProviderConfigListProviderNotConfigured: (providerName: string) =>
    `cash-management-configurable-providers-${providerName}-not-configured`,
  getSettlementRow: (id: UUID) => `settlement-row-${id}`,
  getSettlementRowAmountCell: (id: UUID) => `settlement-row-${id}-amount-cell`,
  getSettlementRowCreatedAtCell: (id: UUID) =>
    `settlement-row-${id}-created-at-cell`,
  getSettlementRowCurrencyCell: (id: UUID) =>
    `settlement-row-${id}-currency-cell`,
  getSettlementRowCustomerCell: (id: UUID) =>
    `settlement-row-${id}--customer-cell`,
  getSettlementRowIdCell: (id: UUID) => `settlement-row-${id}-id-cell`,
  getSettlementRowReportCell: (id: UUID) => `settlement-row-${id}-report-cell`,
  getSettlementRowStatusCell: (id: UUID) => `settlement-row-${id}-status-cell`,
  getSettlementRowTriggerCell: (id: UUID) =>
    `settlement-row-${id}-trigger-cell`,
  getSettlementStatus: (status: string) => `settlement-${status}-status`,
  goBackToConnectSettingsLink: "go-back-to-connect-settings-link",
  isxDomain: "isx-domain",
  isxFinancialConfigurationBreadcrumb: "isx-financial-configuration-breadcrumb",
  isxFinancialPayoutConfigCheckbox: "isx-financial-payout-config-checkbox",
  isxHmacKey: "isx-hmac-key",
  isxMerchantId: "isx-merchant-id",
  isxNotificationSecret: "isx-notification-secret",
  isxPrivateKey: "isx-private-key",
  isxSubDomain: "isx-sub-domain",
  masterAccountNumber: "cash-management-account-provider-iban-content",
  masterAccountNumberClipboardButton:
    "cash-management-account-provider-iban-clipboard-button",
  masterAccountNumberField:
    "cash-management-banking-circle-master-account-number",
  notificationsTab: "notifications-tab",
  paymentsBreadcrumb: "payments-breadcrumb-link",
  payoutNotificationsCardConfigureButton: "payout-notifications-configure",
  payoutNotificationsCardDropdownButton:
    "payout-notifications-card-dropdown-button",
  payoutNotificationsCardEditButton: "payout-notifications-card-edit-button",
  payoutNotificationsCardTestButton: "payout-notifications-card-test-button",
  payoutNotificationsFormUrl: "payout-notifications-form-url",
  payoutNotificationsSecret: "payout-notifications-secret",
  payoutNotificationsStatusLabel: "payout-notifications-status-label",
  payoutNotificationsStatusToggle: "payout-notifications-status-toggle",
  payoutNotificationsUrl: "payout-notifications-url",
  providerCardBankingCircleMasterAccountNumber:
    "cash-management-account-provider-iban-content",
  providerCardProviderId: "cash-management-account-provider-id-content",
  providerCardProviderName: "cash-management-account-provider-name",
  providerCardVoltCashManagementVoltAccountId:
    "volt-cash-management-bank-volt-account-id",
  providerConfigCardNotificationSecret:
    "cash-management-config-notificationSecret",
  providerConfigCardRiskScore: "cash-management-config-riskScore",
  providerConfigCardSkeleton: "provider-config-card-skeleton",
  providerConfigCreateBreadcrumb: "breadcrumb-provider-config-create",
  providerConfigDetailsBreadcrumb: "breadcrumb-provider-config-details",
  providerConfigEditBreadcrumb: "breadcrumb-provider-config-edit",
  providerConfigFormNotificationSecret: "customer-provider-notificationSecret",
  providerConfigFormRiskScore: "customer-provider-riskScore",
  providersTab: "providers-tab",
  refreshAllBalancesButton: "refresh-all-balances-button",
  reportNotificationsCard: "cash-management-report-notifications-title",
  reportNotificationsCardActiveToggle: "switch-label",
  reportNotificationsCardConfigureButton: "configure-report-notifications",
  reportNotificationsCardDropdownButton:
    "report-notifications-card-dropdown-button",
  reportNotificationsCardEditButton: "report-notifications-card-edit-button",
  reportNotificationsCardFailingNotificationsEmail:
    "cash-management-report-notifications-alert-email",
  reportNotificationsCardNotificationsSecret:
    "cash-management-report-notifications-secret",
  reportNotificationsCardNotificationsUrl:
    "cash-management-report-notifications-url",
  reportNotificationsCardStatus: "report-notifications-card-status",
  reportNotificationsCardTestButton: "report-notifications-card-test-button",
  reportNotificationsFormEmail: "report-notifications-form-email",
  reportNotificationsFormUrl: "report-notifications-form-url",
  reportNotificationsSettings: "breadcrumb-notifications",
  reportNotificationsStatusDisabled:
    "cash-management-report-notifications-status-disabled",
  reportNotificationsStatusEnabled:
    "cash-management-report-notifications-status-enabled",
  reportNotificationStatusTag:
    "cash-management-report-notifications-status-not-configured",
  reserveConfigurationFormAmount: "reserve-configuration-form-amount",
  reserveStatusLabel: "reserve-status-label",
  reserveStatusToggle: "reserve-status-toggle",
  scheduleConfigurationFormDay: "schedule-configuration-form-day",
  scheduleConfigurationFormFrequency: "schedule-configuration-form-frequency",
  scheduleConfigurationFormMinAmount: "schedule-configuration-form-min-amount",
  scheduleConfigurationFormThreshold: "schedule-configuration-form-threshold",
  scheduleConfigurationFormTime: "schedule-configuration-form-time",
  scheduleConfigurationFormType: "schedule-configuration-form-type",
  scheduleConfigurationFormWeekday: "schedule-configuration-form-weekday",
  scheduleConfigurationStatusLabel: "schedule-configuration-status-label",
  scheduleConfigurationStatusToggle: "schedule-configuration-status-toggle",
  settleAllAccountsConfirmationButton:
    "settle-all-accounts-confirmation-button",
  settlementDetailsAccountName: "settlement-details-account-name",
  settlementDetailsAccountNumber: "settlement-details-account-number",
  settlementDetailsAmount: "settlement-details-amount",
  settlementDetailsCurrency: "settlement-details-currency",
  settlementDetailsCustomerId: "settlement-details-customer-id",
  settlementDetailsCustomerName: "settlement-details-customer-name",
  settlementDetailsHeader: "settlement-details-header",
  settlementDetailsIban: "settlement-details-iban",
  settlementDetailsId: "settlement-details-id",
  settlementDetailsReference: "settlement-details-reference",
  settlementDetailsSortCode: "settlement-details-sort-code",
  settlementDetailsSwift: "settlement-details-swift",
  settlementDetailsTriggerType: "settlement-details-trigger-type",
  settlementModelCardEnableSettlementBatches:
    "settlement-model-card-enable-settlement-batches",
  settlementModelCardTagDisabled:
    "cash-management-account-settlement-model-automatic-enabled",
  settlementModelCardTagEnabled:
    "cash-management-account-settlement-model-automatic-enabled",
  settlementsBreadcrumb: "settlements-breadcrumb-link",
  settlementsDetailsAsideSkeleton: "settlements-details-aside-skeleton",
  settlementsDetailsAsideSkeletonCard:
    "settlements-details-aside-skeleton-card",
  settlementSettingsReserveConfigureButton:
    "settlement-settings-reserve-configure-button",
  settlementSettingsReserveConfigureCard:
    "settlement-settings-reserve-configure-card",
  settlementSettingsReserveConfiguredCard:
    "settlement-settings-reserve-configured-card",
  settlementSettingsReserveEditButton:
    "settlement-settings-reserve-edit-button",
  settlementSettingsReserveSkeleton: "settlement-settings-reserve-skeleton",
  settlementSettingsScheduleConfigureCard:
    "settlement-settings-schedule-configure-card",
  settlementSettingsScheduleConfiguredCard:
    "settlement-settings-schedule-configured-card",
  settlementSettingsScheduleEditButton:
    "settlement-settings-schedule-edit-button",
  settlementSettingsScheduleSkeleton: "settlement-settings-schedule-skeleton",
  settlementSettingsTab: "settlement-settings-tab",
  settlementSettingsThreshold: "settlement-settings-threshold-item",
  triggerSettlementBatchesButton: "submit-settlement-batch",
  voltCashManagementBankVoltAccountId:
    "volt-cash-management-bank-volt-account-id",
  voltCashManagementBankVoltAccountIdClipboardButton:
    "volt-cash-management-bank-volt-account-id-clipboard-button",
  walletId: "cash-management-wallet-id-content",
  walletIdClipboardButton: "cash-management-wallet-id-clipboard-button",
} as const;
